import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=338a1496&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=338a1496&prod&scoped=true&lang=css"
import style1 from "./Documents.vue?vue&type=style&index=1&id=338a1496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a1496",
  null
  
)

export default component.exports